export default __webpack_public_path__ + "locales/ar-SA/Payments.json?hash=61b034de90ff094cd0ef457e30805f32";